import { Program, ProgramPlaylist, ProgramPreview } from '../models/programs.model';

const tag = '[Programs]';

export class ProgramsRequest {
  static readonly type = `${tag} request programs`;
}

export class ProgramsSuccess {
  static readonly type = `${tag} success programs`;
  constructor(public programs: Program[]) {}
}

export class ProgramsFailure {
  static readonly type = `${tag} error programs`;
  constructor(public error: Error) {}
}

export class CreateProgramRequest {
  static readonly type = `${tag} request create program`;
  constructor(public program: Partial<Program>) {}
}

export class CreateProgramSuccess {
  static readonly type = `${tag} success create program`;
  constructor(public radioId: number, public program: Program) {}
}

export class CreateProgramFailure {
  static readonly type = `${tag} error create program`;
  constructor(public error: Error) {}
}

export class EditProgramRequest {
  static readonly type = `${tag} request edit program`;
  constructor(public program: Partial<Program>) {}
}

export class EditProgramSuccess {
  static readonly type = `${tag} success edit program`;
  constructor(public program: Program, public updateIntroOrExtro: boolean) {}
}

export class EditProgramFailure {
  static readonly type = `${tag} error edit program`;
  constructor(public error: Error) {}
}

export class StartEditProgram {
  static readonly type = `${tag} start edit program`;
  constructor(public program: Program) {}
}

export class EndEditProgram {
  static readonly type = `${tag} end edit program`;
}

export class ProgramPlaylistsRequest {
  static readonly type = `${tag} request program playlists`;
  constructor(public programId: number) {}
}

export class ProgramPlaylistsSuccess {
  static readonly type = `${tag} success program playlists`;
  constructor(public program: Program) {}
}

export class ProgramPlaylistsFailure {
  static readonly type = `${tag} error program playlists`;
  constructor(public error: Error) {}
}

export class SetActionAfterEditProgram {
  static readonly type = `${tag} set action after edit program`;
  constructor(public action: any) {}
}

export class ProgramAddPlaylistRequest {
  static readonly type = `${tag} request program add playlist`;
  constructor(
    public programId: number,
    public playlist: Partial<ProgramPlaylist>,
    public position?: number,
  ) {}
}

export class ProgramAddPlaylistSuccess {
  static readonly type = `${tag} success program add playlist`;
  constructor(public programId: number, public playlist?: ProgramPlaylist) {}
}

export class ProgramAddPlaylistFailure {
  static readonly type = `${tag} error program add playlist`;
  constructor(public error: Error) {}
}

export class ProgramEditPlaylistRequest {
  static readonly type = `${tag} request program edit playlist`;
  constructor(public programId: number, public playlist: ProgramPlaylist) {}
}

export class ProgramEditPlaylistSuccess {
  static readonly type = `${tag} success program edit playlist`;
  constructor(public programId: number) {}
}

export class ProgramEditPlaylistFailure {
  static readonly type = `${tag} error program edit playlist`;
  constructor(public error: Error) {}
}

export class ProgramMovePlaylistRequest {
  static readonly type = `${tag} request program move playlist`;
  constructor(public programId: number, public playlist: ProgramPlaylist) {}
}

export class ProgramMovePlaylistSuccess {
  static readonly type = `${tag} success program move playlist`;
  constructor(public programId: number) {}
}

export class ProgramMovePlaylistFailure {
  static readonly type = `${tag} error program move playlist`;
  constructor(public error: Error) {}
}

export class ProgramDuplicatePlaylistRequest {
  static readonly type = `${tag} request program duplicate playlist`;
  constructor(
    public programId: number,
    public playlist: Partial<ProgramPlaylist>,
    public position: number,
  ) {}
}

export class ProgramDuplicatePlaylistSuccess {
  static readonly type = `${tag} success program duplicate playlist`;
  constructor(public programId: number, public playlist: ProgramPlaylist) {}
}

export class ProgramDuplicatePlaylistFailure {
  static readonly type = `${tag} error program duplicate playlist`;
  constructor(public error: Error) {}
}

export class DeleteProgramRequest {
  static readonly type = `${tag} request delete program`;
  constructor(public programId: number) {}
}

export class DeleteProgramSuccess {
  static readonly type = `${tag} success delete program`;
  constructor(public radioId: number, public programId: number) {}
}

export class DeleteProgramFailure {
  static readonly type = `${tag} error delete program`;
  constructor(public error: Error) {}
}

export class DuplicateProgramRequest {
  static readonly type = `${tag} request duplicate program`;
  constructor(public program: Program) {}
}

export class DuplicateProgramSuccess {
  static readonly type = `${tag} success duplicate program`;
  constructor(public radioId: number, public program: Program) {}
}

export class DuplicateProgramFailure {
  static readonly type = `${tag} error duplicate program`;
  constructor(public error: Error) {}
}

export class ProgramDeletePlaylistRequest {
  static readonly type = `${tag} request program delete playlist`;
  constructor(public programId: number, public playlistId: number) {}
}

export class ProgramDeletePlaylistSuccess {
  static readonly type = `${tag} success program delete playlist`;
  constructor(public programId: number, public playlistId?: number) {}
}

export class ProgramDeletePlaylistFailure {
  static readonly type = `${tag} error program delete playlist`;
  constructor(public error: Error) {}
}

export class PreviewProgramRequest {
  static readonly type = `${tag} request preview program`;
  constructor(public programId: number, public cycleIdx = 0) {}
}

export class PreviewProgramSuccess {
  static readonly type = `${tag} success preview program`;
  constructor(public programPreview: ProgramPreview[]) {}
}

export class PreviewProgramFailure {
  static readonly type = `${tag} error preview program`;
  constructor(public error: Error) {}
}

export class StartProgramDetails {
  static readonly type = `${tag} start program details`;
  constructor(public program: Program) {}
}

export class StopProgramDetails {
  static readonly type = `${tag} stop program details`;
}

export class HideIntroExtro {
  static readonly type = `${tag} hide intro extro`;
}
